module.exports = __webpack_public_path__ + "img/success.4fef5549.svg";